import { ReactElement } from 'react'
import {
  Avatar,
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from '@mui/material'
import { CancelIcon } from 'src/v3/core/icons'
import { useAppDispatch, useAppSelector } from 'src/store/hooks'
import useSession from 'src/authentication/hooks/use-session'
import {
  selectActiveLinkedService,
  selectLinkedServicesByIds,
  activeLinkedServiceChanged,
} from 'src/v3/create/create.slice'

export default (): ReactElement => {
  let dispatch = useAppDispatch()
  let session = useSession()

  let linkedServiceID = useAppSelector(selectActiveLinkedService)
  let linkedServices = useAppSelector(
    selectLinkedServicesByIds(session?.linkedServices ?? []),
  )

  let handleChange = (event: SelectChangeEvent) => {
    dispatch(activeLinkedServiceChanged(event.target.value))
  }

  return (
    <FormControl fullWidth>
      <InputLabel id="linked-service-label">Linked Service</InputLabel>
      <Select
        labelId="linked-service-label"
        value={linkedServiceID || ''}
        label="Linked Service"
        onChange={handleChange}
        sx={{ bgcolor: 'background.paperDark' }}
        renderValue={(value) => {
          if (!value) {
            return (
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Avatar sx={{ mr: 2, width: 24, height: 24 }}>
                  <CancelIcon />
                </Avatar>
                No Selection
              </Box>
            )
          }
          let service = linkedServices.find((ls) => ls.id === value)
          return (
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Avatar
                src={`${import.meta.env.VITE_CLOUDFRONT_URL}/public/${service?.imageName}`}
                sx={{ mr: 2, width: 24, height: 24 }}
              >
                LS
              </Avatar>
              {service?.name}
            </Box>
          )
        }}
      >
        <MenuItem value="">
          <Avatar sx={{ mr: 2, width: 24, height: 24 }}>
            <CancelIcon />
          </Avatar>
          No Selection
        </MenuItem>
        {linkedServices.map((ls) => (
          <MenuItem key={ls.id} value={ls.id ?? ''}>
            <Avatar
              src={`${import.meta.env.VITE_CLOUDFRONT_URL}/public/${ls?.imageName}`}
              sx={{ mr: 2, width: 24, height: 24 }}
            >
              LS
            </Avatar>
            {ls.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}
